import { render, staticRenderFns } from "./LayoutError.vue?vue&type=template&id=49a9cc78&scoped=true&"
import script from "./LayoutError.vue?vue&type=script&lang=js&"
export * from "./LayoutError.vue?vue&type=script&lang=js&"
import style0 from "./LayoutError.vue?vue&type=style&index=0&id=49a9cc78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a9cc78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('49a9cc78', component.options)
    } else {
      api.reload('49a9cc78', component.options)
    }
    module.hot.accept("./LayoutError.vue?vue&type=template&id=49a9cc78&scoped=true&", function () {
      api.rerender('49a9cc78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/LayoutError.vue"
export default component.exports